// src/lib/guided/concernAction.ts
//
// Plan 5.4: turns a concern's optional action (config.ts's
// `ConcernActionSchema`: book a call, the pricing page, talk to a person)
// into the link both visitor renderers show below an expanded answer.
// Reuses `outcomeCtaHref`'s own scheme/host check (src/lib/quiz/outcomes.ts)
// rather than a second URL sanitizer -- a concern's `url` is validated with
// zod's `.url()`, which accepts `javascript:` syntactically, exactly the gap
// `ctaForOfferAction`/`outcomeCtaHref` already close for offer CTAs
// (resultScreen.ts's own note on that pair).
import type { ConcernActionType, FunnelConcernAction } from "./config";
import { outcomeCtaHref } from "@/lib/quiz/outcomes";

const CONCERN_ACTION_LABELS: Record<ConcernActionType, string> = {
  book: "Book a call",
  pricing: "See pricing",
  person: "Talk to a person",
};

export interface ConcernActionLink {
  href: string;
  text: string;
}

export function concernActionLink(
  action: FunnelConcernAction | null | undefined,
): ConcernActionLink | null {
  if (!action) return null;
  const text = CONCERN_ACTION_LABELS[action.type];
  const href = outcomeCtaHref({ label: text, url: action.url });
  return href ? { href, text } : null;
}
